import { useEffect, useMemo, useState } from 'react'

/**
 * "Now" for the session/JWT lines in the expanded badge: refreshed every 30 s while the badge is
 * expanded, so token expiry countdowns stay current without re-rendering a collapsed badge.
 */
export function useSessionClock(isExpanded: boolean): number {
  const [sessionTick, setSessionTick] = useState(0)

  useEffect(() => {
    if (!isExpanded) return

    const id = setInterval(() => {
      setSessionTick((t) => t + 1)
    }, 30_000)

    return () => clearInterval(id)
  }, [isExpanded])

  return useMemo(() => {
    void sessionTick
    return Date.now()
  }, [sessionTick])
}
